import React from 'react';
import {
  Pizza, Coffee, Beer, Wine, Martini, CupSoda, GlassWater, Milk,
  Soup, Salad, Sandwich, Beef, Fish, Drumstick, Ham, Egg, EggFried,
  Croissant, Cake, CakeSlice, Cookie, IceCream, IceCreamCone, Candy,
  Donut, Popcorn, Apple, Cherry, Grape, Carrot, Citrus, Nut,
  Utensils, UtensilsCrossed, ChefHat, CookingPot, Vegan, Wheat,
  Hamburger, Lollipop,
} from 'lucide-react';

// Curated list of food & beverage logos selectable per category.
export const CATEGORY_ICONS = [
  { key: 'utensils-crossed', label: 'Ristorante', Icon: UtensilsCrossed },
  { key: 'utensils', label: 'Piatti', Icon: Utensils },
  { key: 'chef-hat', label: 'Chef', Icon: ChefHat },
  { key: 'cooking-pot', label: 'Primi', Icon: CookingPot },
  { key: 'pizza', label: 'Pizza', Icon: Pizza },
  { key: 'hamburger', label: 'Hamburger', Icon: Hamburger },
  { key: 'sandwich', label: 'Panini', Icon: Sandwich },
  { key: 'salad', label: 'Insalate', Icon: Salad },
  { key: 'soup', label: 'Zuppe', Icon: Soup },
  { key: 'beef', label: 'Carne', Icon: Beef },
  { key: 'drumstick', label: 'Pollo', Icon: Drumstick },
  { key: 'ham', label: 'Salumi', Icon: Ham },
  { key: 'fish', label: 'Pesce', Icon: Fish },
  { key: 'egg', label: 'Uova', Icon: Egg },
  { key: 'egg-fried', label: 'Colazione', Icon: EggFried },
  { key: 'croissant', label: 'Brioche', Icon: Croissant },
  { key: 'wheat', label: 'Pasta', Icon: Wheat },
  { key: 'vegan', label: 'Vegano', Icon: Vegan },
  { key: 'carrot', label: 'Verdure', Icon: Carrot },
  { key: 'apple', label: 'Frutta', Icon: Apple },
  { key: 'cherry', label: 'Ciliegie', Icon: Cherry },
  { key: 'grape', label: 'Uva', Icon: Grape },
  { key: 'citrus', label: 'Agrumi', Icon: Citrus },
  { key: 'nut', label: 'Frutta secca', Icon: Nut },
  { key: 'cake', label: 'Torte', Icon: Cake },
  { key: 'cake-slice', label: 'Dolci', Icon: CakeSlice },
  { key: 'ice-cream', label: 'Gelato', Icon: IceCream },
  { key: 'ice-cream-cone', label: 'Coni', Icon: IceCreamCone },
  { key: 'cookie', label: 'Biscotti', Icon: Cookie },
  { key: 'donut', label: 'Ciambelle', Icon: Donut },
  { key: 'candy', label: 'Caramelle', Icon: Candy },
  { key: 'lollipop', label: 'Lecca-lecca', Icon: Lollipop },
  { key: 'popcorn', label: 'Snack', Icon: Popcorn },
  { key: 'coffee', label: 'Caffè', Icon: Coffee },
  { key: 'cup-soda', label: 'Bibite', Icon: CupSoda },
  { key: 'glass-water', label: 'Acqua', Icon: GlassWater },
  { key: 'milk', label: 'Latte', Icon: Milk },
  { key: 'beer', label: 'Birra', Icon: Beer },
  { key: 'wine', label: 'Vino', Icon: Wine },
  { key: 'martini', label: 'Cocktail', Icon: Martini },
];

const ICON_MAP = CATEGORY_ICONS.reduce((acc, i) => { acc[i.key] = i.Icon; return acc; }, {});

export const DEFAULT_CATEGORY_ICON = 'utensils-crossed';
export const DEFAULT_CATEGORY_COLOR = '#2563eb';

export function getCategoryIcon(key) {
  return ICON_MAP[key] || ICON_MAP[DEFAULT_CATEGORY_ICON];
}

// Rich, modern swatches the user can pick from (plus a free custom color).
export const CATEGORY_COLORS = [
  '#2563eb', '#0ea5e9', '#06b6d4', '#14b8a6',
  '#10b981', '#22c55e', '#84cc16', '#eab308',
  '#f59e0b', '#f97316', '#ef4444', '#ec4899',
  '#a855f7', '#8b5cf6', '#6366f1', '#64748b',
];

/** Render a category logo with its custom color. */
export const CategoryIcon = ({ iconKey, color, className, style }) => {
  const Icon = getCategoryIcon(iconKey);
  return <Icon className={className} style={color ? { color, ...style } : style} />;
};
